export default "__VITE_ASSET__vU2_kSkB__"